export var configDocs = {
  name: 'config',
  category: 'Core',
  syntax: ['config()', 'config(options)'],
  description: 'Get configuration or change configuration.',
  examples: ['config()', '1/3 + 1/4', 'config({number: "Fraction"})', '1/3 + 1/4'],
  seealso: []
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/es/expression/embeddedDocs/core/config.js
// module id = null
// module chunks = 